import React, { useState, useEffect } from 'react';
import { Layout, Button } from 'antd';
import { useLocation } from 'react-router-dom';
import { MenuOutlined } from '@ant-design/icons';
import Sidebar from './Sidebar';
import { BREAKPOINTS } from '../../constants/breakpoints';

const { Content } = Layout;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < BREAKPOINTS.lg);
  const location = useLocation();

  // Pages that need edge-to-edge (no padding) — they manage their own layout
  const isFullWidthPage = location.pathname.includes('/estimates/new') ||
    location.pathname.includes('/estimates/edit') ||
    (location.pathname.includes('/estimates/') && location.pathname.split('/').length > 4);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < BREAKPOINTS.lg;
      setIsMobile(mobile);
      if (mobile) {
        setSidebarCollapsed(true);
      }
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSidebarCollapse = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  // Desktop: content shifts right by sidebar width
  // Mobile: content is full-width, sidebar overlays
  const contentMarginLeft = isMobile ? '0' : (sidebarCollapsed ? '80px' : '280px');
  const contentPadding = isMobile ? '8px' : '20px';

  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#f5f7fa' }}>
      <Sidebar collapsed={sidebarCollapsed} onCollapse={handleSidebarCollapse} />

      <Layout style={{
        marginLeft: contentMarginLeft,
        transition: 'margin-left 0.3s ease',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}>
        {/* Mobile Top Bar */}
        {isMobile && (
          <div style={{
            height: '52px',
            backgroundColor: 'white',
            borderBottom: '1px solid #e5e7eb',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 12px',
            position: 'sticky',
            top: 0,
            zIndex: 100,
            flexShrink: 0,
          }}>
            <Button
              type="text"
              icon={<MenuOutlined style={{ fontSize: '20px' }} />}
              onClick={() => setSidebarCollapsed(false)}
              style={{
                width: '44px',
                height: '44px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0,
              }}
            />
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <div style={{
                width: '26px',
                height: '26px',
                backgroundColor: '#2563eb',
                borderRadius: '6px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
                <span style={{ color: 'white', fontSize: '10px', fontWeight: 'bold' }}>CNF</span>
              </div>
              <span style={{ fontWeight: '600', color: '#111827', fontSize: '14px' }}>CNF Auto</span>
            </div>
            <div style={{ width: '44px' }} />
          </div>
        )}

        <Content
          style={{
            overflowX: 'hidden',
            padding: isFullWidthPage ? 0 : contentPadding,
            flex: 1,
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
